import jsPDF from "jspdf";
import axios from "axios";
import JsBarcode from "jsbarcode";
import Select from "react-select";
import { Link, useParams } from "react-router-dom";
import config from "../../../../config/config";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import {CUSTOM_SELECT_DROPDOWN_STYLE, SUCCESS_MESSAGE} from "../../../../common/Constant";
import Loader from "../../../../components/Loader/Loader";
import React, { useEffect, useState, useRef } from "react";
import { GetDataForBarcodeGeneration } from "../Items/NewInventoryCount";
import { toastError, toastSuccess } from "../../../../common/Toast";

const CountInventoryBarcodeLabel = () => {
  const paramObject = useParams();
  const [formValues, setFormValues] = useState([]);
  const barcodeRefs = useRef([]);
  const barcodeRequestParam = localStorage.getItem("BarcodeRequestParam");
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const token = localStorage.getItem("Token");
  const settingids = localStorage.getItem("barcode-settings");
  const [selectedValue, setSelectedValue] = useState([]);
  
  const [placeHolder, setPlaceHolder] = useState("Load Selected Values");
  const [id, setId] = useState(0);
  const [data, setData] = useState({
    inputValue: "",
    width: 1,
    height: 20,
    fontSize: 15,
    zeroFill: 10,
  });

  // const selectStyles = {
  //   control: (provided) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "40px",
  //     position: "relative",
  //   }), // dropdown input css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
  //     position: "absolute",
  //     background: "#f8f8f8",
  //     width: "100%",
  //     zIndex: 99,
  //   }), // dropdown menu css
  // };

  const handleChange = (event) => {
    
    if (event.target.name == "inputValue") {
      setData({ ...data, [event.target.name]: event.target.value });
    } else {
      setData({ ...data, [event.target.name]: parseInt(event.target.value) });
    }
  };

  useEffect(() => {
    generateBarcodes();
  }, [data]);

  const generateBarcodes = () => {
    barcodeRefs.current.forEach((barcodeRef, index) => {
      var g = document.getElementsByTagName(barcodeRef);
      const dataItemId = barcodeRef.getAttribute("data-itemid");
      const barcodeValue = dataItemId;
      const paddedBarcodeValue = barcodeValue.padStart(data.zeroFill, "0"); // Zerofill at the barcode
      JsBarcode(barcodeRef, paddedBarcodeValue, {
        width: data.width,
        height: data.height,
        fontSize: data.fontSize,
        displayValue: true,
        fontoptions: "bold",
        textAlign: "center",
        font: "monospace",
        textPosition: "bottom",
        textMargin: 2,
        margin: 0,
        marginTop: undefined,
        marginBottom: undefined,
        marginLeft: undefined,
        marginRight: undefined,
        format: "CODE128",
        valid: () => true,
        background: "#ffffff",
        lineColor: "#000000",
        padding: data.zeroFill,
      });
    });
  };

  const resetpage = () => {
    window.location.reload();
    localStorage.removeItem("barcode-settings");
  };

  //Function for downloading pdf
  const downloadPdf = () => {
    const pdf = new jsPDF();
    barcodeRefs.current.forEach((barcodeRef) => {
      const canvas = barcodeRef;
      const imgData = canvas.toDataURL("image/png");
      pdf.addImage(imgData, "PNG", 10, 10);
      pdf.addPage();
    });
    pdf.save("barcodes.pdf");
  };

  // useEffect for getting the selected data
  useEffect(() => {
    axios
      .get(`${config.generalBaseUrl}/generals/barcodelisting`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setOptions(res.data.ResponseData);
        setLoading(false);
        generateBarcodes();

        res.data.ResponseData.map((data) => {
          if (settingids?.includes(data?.ID)) {
            setSelectedValue({
              value: data?.ID,
              label: data?.SaveAs_Name,
            });
          }
        });
      })
      .catch((err) => {});

    let getbarcodedatafromnewcountinventory = GetDataForBarcodeGeneration();

    let transformedArray = [];

    getbarcodedatafromnewcountinventory?.forEach((obj) => {
      for (let i = 0; i < obj.Counts; i++) {
        const newObj = {
          AutoIncrementId: transformedArray.length + 1,
          Id: obj.Id,
          VariationName: obj.VariationName,
          ItemId: obj.ItemId,
          CostPrice: obj.CostPrice,
          UnitPrice: obj.UnitPrice,
        };
        transformedArray.push(newObj);
      }
    });
    setFormValues(transformedArray);
    setTimeout(function () {
      generateBarcodes();
    }, 2000);
  }, []);

  // Function for setting the value and updating the data
  const handleUpdate = (event) => {
    const selectedOption = options.find(
      (option) => option.value === event.value
    );
    setSelectedValue(event);

    axios
      .get(
        `${config.generalBaseUrl}/generals/barcodeselectbyid?id=${event.value}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setId(res.data.ResponseData[0]?.ID);
        const data = {
          width: res.data.ResponseData[0].BarcodeImageWidth,
          height: res.data.ResponseData[0].BarcodeImageHeight,
          fontSize: res.data.ResponseData[0].BarcodeImageFontSize,
          zeroFill: res.data.ResponseData[0].ZerofillBarcode,
          inputValue: res.data.ResponseData[0].SaveAs_Name,
        };
        setData(data);
      })
      .catch((err) => {});
  };

  //Function for inserting the data
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (
      data.inputValue == null ||
      data.inputValue == undefined ||
      data.inputValue == ""
      // id == id
    ) {
      generateBarcodes();
    } else {
      try {
        const allDataToSend = {
          ID: id,
          BarcodeImageWidth: data.width,
          BarcodeImageHeight: data.height,
          BarcodeImageFontSize: data.fontSize,
          ZerofillBarcode: data.zeroFill,
          SaveAs_Name: data.inputValue,
        };
        axios.post(
          `${config.generalBaseUrl}/generals/barcodeupsert`,
          allDataToSend,
          {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
            toastSuccess(SUCCESS_MESSAGE);
            generateBarcodes();
            localStorage.setItem(
              "barcode-settings",
              JSON.stringify(res.data.ResponseID)
            );
           
          } else if (
            res.data.ResponseCode === "ERROR" &&
            res.data.ResponseID === -1
          ){
            toastError("ERROR");
          }
        })
        .catch((err) => {});
       
        axios
          .get(`${config.generalBaseUrl}/generals/barcodelisting`, {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          })
          .then((res) => {
            setOptions(res.data.ResponseData);
            setLoading(false);
            generateBarcodes();

            res.data.ResponseData.map((data) => {
              if (settingids?.includes(data?.ID)) {
                setSelectedValue({
                  value: data?.ID,
                  label: data?.SaveAs_Name,
                });
              }
            });
          })
          .catch((err) => {});

        let getbarcodedatafromnewcountinventory = GetDataForBarcodeGeneration();

        let transformedArray = [];

        getbarcodedatafromnewcountinventory?.forEach((obj) => {
          for (let i = 0; i < obj.Counts; i++) {
            const newObj = {
              AutoIncrementId: transformedArray.length + 1,
              Id: obj.Id,
              VariationName: obj.VariationName,
              ItemId: obj.ItemId,
              CostPrice: obj.CostPrice,
              UnitPrice: obj.UnitPrice,
            };
            transformedArray.push(newObj);
          }
        });
        setFormValues(transformedArray);
        setTimeout(function () {
          generateBarcodes();
        }, 2000);
        // axios
        //   .get(`${config.workorderBaseUrl}/workorders/barcodeselectalltype`, {
        //     headers: {
        //       "Content-Type": "application/json;charset=UTF-8",
        //       Authorization: token,
        //     },
        //   })
        //   .then((res) => {
        //     setOptions(res.data.ResponseData);
        //     setLoading(false);
        //     generateBarcodes();

        //     res.data.ResponseData.map((data) => {
        //       if (settingids?.includes(data?.Id)) {
        //         setSelectedValue({
        //           value: data?.Id,
        //           label: data?.SaveAsName,
        //         });
        //         //handleUpdate({ value: data?.ID, label: data?.SaveAsName });
        //       }
        //     });
        //   })
        //   .catch((err) => {});

        // let getbarcodedatafromnewcountinventory = GetDataForBarcodeGeneration();

        // let transformedArray = [];

        // getbarcodedatafromnewcountinventory?.forEach((obj) => {
        //   for (let i = 0; i < obj.Counts; i++) {
        //     const newObj = {
        //       AutoIncrementId: transformedArray.length + 1,
        //       Id: obj.Id,
        //       VariationName: obj.VariationName,
        //       ItemId: obj.ItemId,
        //       CostPrice: obj.CostPrice,
        //       UnitPrice: obj.UnitPrice,
        //     };
        //     transformedArray.push(newObj);
        //   }
        // });
        // setFormValues(transformedArray);
        // setTimeout(function () {
        //   generateBarcodes();
        // }, 2000);
        // window.location.reload();
      } catch (error) {}
      setLoading(false);
    }
  };

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div className="page-header" 
          style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}>
            <div className="row breadcrumb-position">
              {/* <h3>Count Inventory</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/items">Items</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/item-count-invetory">Count Inventory</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to={`/new-inventory-count/${paramObject?.id > 0 ? paramObject?.id : ''}`}>
                    New Inventory Count
                  </Link>
                </li>
                <li className="breadcrumb-item active">Barcode Label</li>
              </ul>
            </div>
          </div>
          <br />
          <br />
          <div className="card">
            <div className="card-body">
              {/* input field */}

              <div className="col-md-4">
                <Select
                  backspaceRemovesValue={false}
                  controlShouldRenderValue={true}
                  hideSelectedOptions={true}
                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                  isClearable={true}
                  onChange={(event) => handleUpdate(event)}
                  options={options.map((data) => ({
                    value: data.ID,
                    label: data.SaveAs_Name,
                  }))}
                  {...(selectedValue.value !== undefined ? (
                    <input value={selectedValue} />
                  ) : (
                    <input placeholder={placeHolder} />
                  ))}
                />
              </div>
              <br />

              <div className="row">
                <div className="mt-2 col-sm-4">
                  <label className="col-form-label p-lg-medium">Barcode Image Width: </label>
                  <input
                    name="width"
                    type="number"
                    value={data.width}
                    className="form-control "
                    onChange={handleChange}
                  />
                </div>
                <div className="mt-2 col-sm-4">
                  <label className="col-form-label p-lg-medium">Barcode Image Height: </label>
                  <input
                    name="height"
                    type="number"
                    value={data.height}
                    className="form-control"
                    onChange={handleChange}
                  />
                </div>

                <div className="mt-2 col-sm-4">
                  <label className="col-form-label p-lg-medium">Barcode Image FontSize: </label>
                  <input
                    name="fontSize"
                    type="number"
                    value={data.fontSize}
                    className="form-control"
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="row">
                <div className="mt-2 col-sm-4">
                  <label className="col-form-label p-lg-medium">Barcode Zero Fill: </label>
                  <input
                    name="zeroFill"
                    type="number"
                    value={data.zeroFill}
                    className="form-control"
                    onChange={handleChange}
                  />
                </div>
                <div className="mt-2 col-sm-4">
                  <label className="col-form-label p-lg-medium">Save Settings Above As:</label>
                  <input
                    name="inputValue"
                    type="text"
                    value={data.inputValue}
                    className="form-control"
                    onChange={handleChange}
                  />
                </div>
              </div>
              <br />
              <div className="row">
                <div className="col-12">
                  <button
                    type="submit"
                    className="btn btn-primary me-1"
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>
                  <button
                    type="submit"
                    className="btn btn-secondary me-1"
                    onClick={resetpage}
                  >
                    Reset
                  </button>
                  <button
                    type="submit"
                    className="btn btn-secondary"
                    onClick={downloadPdf}
                  >
                    Download PDf
                  </button>
                </div>
              </div>
              <br />
              <br />
              {/* Generating the barcode with the help of Id */}
              {formValues.map((item, index) => (
                <>
                  <div className="col-md-12 text-center" key={index}>
                    <div key={item.AutoIncrementId} className="mb-4">
                      <div className="col-form-label p-lg-medium">Sonar POS</div>
                      <canvas
                        data-itemid={item.Id}
                        data-name={item.AutoIncrementId}
                        ref={(el) =>
                          (barcodeRefs.current[item.AutoIncrementId] = el)
                        }
                        id={`barcode-${item.AutoIncrementId}`}
                      />
                      <div className="gap-0">
                        ${parseFloat(item.UnitPrice).toFixed(2)}&nbsp;&nbsp;
                        {item.VariationName}
                      </div>
                    </div>
                  </div>
                </>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CountInventoryBarcodeLabel;
